<template>
  <div id="modalEditDateSu" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-lg" role="document">
      <div class="modal-content bd-0 tx-14">
         <modal-loading :show="loading"></modal-loading> 
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("stockout.填写备注")}}</h6>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
        	<div class="form-group row align-items-center">
	          <label class="col-md-2 col-sm-12 col-form-label form-control-sm text-right pd-0">{{$t("stockout.备注")}}<span class=" tx-danger">*</span>：</label> 
        		<div class="col-md-8 col-sm-12 pd-l-10">
        			<textarea v-model="remark" rows="3" name="remark" class="form-control form-control-sm tx-13"></textarea>
    				</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="save()">{{$t("stockout.确定")}}</button>
          <button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("stockout.取消")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open","info"],
  data() {
    return {
    	loading:false,
    	remark:"",
    	dateFrom:""
    }
  },
  created() {
  },
  updated() {
  },
  watch:{
  	open: function(){
  		
  		this.loading = false;
  		this.remark = "";
  	},
  },
  methods: {
  	save(){
  		let vm = this;
	  	if(!vm.remark){
	  		ShowTip(this.$t('stockout.填写预计到货时间必须填写该备注'), "danger");
	  	} else{
	  		vm.loading = true;
	  		$.api_call("api.OutOfStockList.addRemarkBySupplier",{
		  		id: vm.info.id,
		  		remark: vm.remark,
		  	}, (r)=> {
		          vm.loading = false;
		          if (r.ErrorCode == "9999") {
		            ShowTip(this.$t('stockout.成功填写备注'), "success");
		            $("#modalEditDateSu").modal("hide");
		            vm.$parent.getStockoutList();
		          } else {
		            ShowTip(r.Message, "danger");
		          }
		        }
		  	);
	  	}
  	}
  }
};
</script>
<style scoped>
#modalEditDateSu [data-id="datepicker-from"],
#modalEditDateSu [data-id="datepicker-to"] {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.15);
  color: #495057;
}
.img-wrap {
  width: 2rem;
  height: 2rem;
  background-size: 100%;
}
</style>
